import { useConditionFieldTypeFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionFieldTypeWarning = () => {
  const fieldPath = useConditionFieldTypeFieldPath();
  const { getHasWarningFromFieldPath } = useQueryErrorStateContext();
  const warningFromFieldPath = getHasWarningFromFieldPath(fieldPath);

  return warningFromFieldPath;
};
